<template>
    <div class="category" v-if="filteredDishes.length">

        <h3 class="category__title remove-v-margin2">
            <span>{{ title }} <span class="category__time">{{ time(activeTimespan.begin, activeTimespan.end) }}</span></span>
            {{ filteredDishes.length}} / {{ dishes.length }}
        </h3>

        <div class="frame-breakout-h-medium native-scroll hide-scrollbars">
            <div class="native-scroll__track fix-vertical-scroll frame-h-medium">
                <Dish v-for="item in filteredDishes" :key="item.key"
                      v-bind="item" class="native-scroll__item"
                      :image="item.image.list"
                      :sections="sections"
                      @click.native="$emit('select-dish', item)" />
            </div>
        </div>

    </div>
</template>

<script>
import { wrapFunction } from '../js/utils.js';

import format from 'date-fns/format';

const pad = (n) => {
    return n < 10 ? '0' + n : n;
}

export default {
    name: 'Category',
    computed: Object.assign({}, wrapFunction(`
        title
        filteredDishes
        activeTimespan
        dishes
    `), {
        isActive() {
            return false;
        }
    }),
    props: {
        data: Object,
        image: String,
        sections: Array,
    },
    methods: {
        getIntolerances() {
            return (this.intolerances || []).map(i => i.label).join(', ');
        },
        time(begin, end) {
            if (begin === 0 || end === 0) return '';

            const beginHours = begin.getHours();
            const beginMinutes = begin.getMinutes();
            const endHours = end.getHours();
            const endMinutes = end.getMinutes();

            let beginStr = `${pad(beginHours)}.${pad(beginMinutes)}`;
            let endStr = `${pad(endHours)}.${pad(endMinutes)}`;

            if (beginHours === endHours && beginMinutes === 0) {
                beginStr = pad(beginHours);
            }

            return `${beginStr}-${endStr} ${this.bclang('Uhr')}`;
        }
    }
}
</script>

<style lang="scss">

@import '../scss/config';

.category {
    position: relative;
    margin-bottom: 0;
    margin-top: size(large);

    &:first-of-type {
        margin-top: size(huge) / 2;
    }

    &__title {
        font-size: size(font-regular);
        margin-bottom: size(small);
        line-height: 1;
        display: flex;
        justify-content: space-between;
    }

    &__time {
        @include font-regular();
        color: color(middleground);
    }
}
</style>
